import { Stack, Typography } from "@mui/material";
import { Calendar } from "../../Schedule/Schedule/Calendar";
import {
  ITriageCheckInRule,
  ITriageEmergencyDepartments,
} from "../../../models/triage";
import { CheckInButtonTriage } from "./CheckInButtonTriage";

const TriageItem = ({
  data,
  checkInRule,
}: {
  data: ITriageEmergencyDepartments;
  checkInRule: ITriageCheckInRule;
}) => {
  return (
    <Stack
      sx={(t) => ({
        flexDirection: "row",
        gap: t.spacing(2),
        padding: t.spacing(2),
        backgroundColor: t.palette.divider,
        borderRadius: t.shape.borderRadius / 2,
      })}
    >
      <Calendar date={data.created} />
      <Stack
        sx={(t) => ({
          justifyContent: "space-between",
          flexGrow: 1,
          padding: t.spacing(1),
          flex: 1,
        })}
      >
        <Stack
          sx={(t) => ({
            flexDirection: "row",
            justifyContent: "space-between",
            gap: t.spacing(1),
            alignItems: "center",
          })}
        >
          <Typography style={{ flex: 1, fontWeight: "500" }}>
            {data.anamnesis}
          </Typography>
        </Stack>
        <Typography style={{ alignSelf: "flex-end", fontSize: 15 }}>
          {data.individual.name}
        </Typography>
        {checkInRule && (
          <CheckInButtonTriage
            patientEncounterId={data.patientEncounterId}
            checkInRule={checkInRule}
            created={data.created}
            individualTasyInsuranceFavorite={
              data.individualTasyInsuranceFavorite
            }
            id={data.id}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default TriageItem;
